import React, { useState, useEffect } from "react";
import "./style.css";
import { IoMdClose } from "react-icons/io";


export default function AttachmentDetailPopUp({ selectedFileDetails, closeFn }) {
    const [formData, setFormData] = useState({
        altText: "",
        title: "",
        description: "",
        fileUrl: ""
    });
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };
    const handleCopy = () => {
        navigator.clipboard.writeText(formData.fileUrl);
        alert("File URL copied to clipboard!");
    };

    useEffect(() => {
        if (selectedFileDetails) {
            setFormData({
                altText: selectedFileDetails.altText || "",
                title: selectedFileDetails.title || "",
                description: selectedFileDetails.description || "",
                fileUrl: "https://fdapi.thefurnituredepots.com" + selectedFileDetails.imageUrl || ""
            });
        }
    }, [selectedFileDetails]);
    return (
        <div className="popup_attachemnt_bg_main">
            <div className="attachment_detail_pop_up">
                <div className="header_adpu">
                    <h2>Attachment Details</h2>
                    <div className="cross_btn_adpu" onClick={() => { closeFn() }}>
                        <IoMdClose size={25} />
                    </div>
                </div>
                <div className="left_side_adpu">
                    <img src={"https://fdapi.thefurnituredepots.com" + selectedFileDetails.imageUrl} />
                </div>
                <div className="right_side_adpu">
                    <div className="details_1_rsadpu">
                        <div className="details_1_rsadpu_detail">
                            <p>Uploaded on</p>
                            <span>{selectedFileDetails.uploadedOn}</span>
                        </div>
                        <div className="details_1_rsadpu_detail">
                            <p>Uploaded by</p>
                            <span>{selectedFileDetails.uploadedBy}</span>
                        </div>
                        <div className="details_1_rsadpu_detail">
                            <p>Uploaded to</p>
                            <span style={{ cursor: "pointer", color: "#0056b3" }}>{selectedFileDetails.uploadedTo}</span>
                        </div>
                        <div className="details_1_rsadpu_detail">
                            <p>File Name</p>
                            <span>{selectedFileDetails.fileName}</span>
                        </div>
                        <div className="details_1_rsadpu_detail">
                            <p>File Type</p>
                            <span>{selectedFileDetails.fileType}</span>
                        </div>
                        <div className="details_1_rsadpu_detail">
                            <p>File Size</p>
                            <span>{selectedFileDetails.fileSize}</span>
                        </div>
                        <div className="details_1_rsadpu_detail">
                            <p>Dimensions</p>
                            <span>{selectedFileDetails.dimensions}</span>
                        </div>
                    </div>
                    <div className="line_divider_rsadpu"></div>
                    <div className="details_2_rsadpu">
                        <div className="details_2_rsadpu_detail">
                            <p>Alternative Text</p>
                            <input
                                type="text"
                                name="altText"
                                value={formData.altText}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="details_2_rsadpu_detail">
                            <p>Title</p>
                            <input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="details_2_rsadpu_detail">
                            <p>Description</p>
                            <textarea
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="details_2_rsadpu_detail">
                            <p>File URL</p>
                            <input
                                type="text"
                                name="fileUrl"
                                value={formData.fileUrl}
                                onChange={handleChange}
                            />
                            <button type="button" onClick={handleCopy}>
                                Copy to Clipboard
                            </button>
                        </div>
                    </div>
                    <div className="line_divider_rsadpu"></div>
                    <div className="details_3_rsadpu">
                        <button
                            className="view_at"
                            onClick={() => window.open("https://fdapi.thefurnituredepots.com" + selectedFileDetails.imageUrl, "_blank")}
                        >
                            View Attachment
                        </button>

                        <button
                            className="downl_fl"
                            onClick={() => {
                                const link = document.createElement("a");
                                link.href = "https://fdapi.thefurnituredepots.com" + selectedFileDetails.imageUrl;
                                link.download = selectedFileDetails.fileName || "attachment";
                                link.target = "_blank"; // Optional, in case you want it to open in a new tab if not downloadable
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            }}
                        >
                            Download File
                        </button>

                        <button className="del_perm">Delete Permanently</button>
                    </div>
                </div>
            </div>
        </div>

    )
}